import { DocumentCommittee } from "../../../models/Request";

export const getSelectedEmployeeIds = (
  committee: DocumentCommittee
): number[] => {
  return committee.committeeEmployees.reduce<number[]>((acc, employee) => {
    if (employee.isCommitteeEmployeeSelected) {
      acc.push(employee.committeeEmployeeId);
    }
    return acc;
  }, []);
};
